'use strict';

angular.module('shiftTraderApp')
  .controller('ReviewWeekScheduleCtrl', function ($scope, $uibModalInstance, params, initialProjections,
                                                  workPeriods, $rootScope, MWPHighlightService,
                                                  TimeService, Users, AvailabilityRules,
                                                  AvailabilitySets, $q, $timeout, $interval,
                                                  WeekCalculationService, MWPCompositeAvailabilityService) {
    $scope.me = params.me;
    $scope.org = params.org;
    $scope.dates = params.dates;
    $scope.dayTwixes = lodash.map($scope.dates, function(dt) {
      return moment(dt).twix(moment(dt).add(1, 'days'));
    });

    $scope.workPeriods = lodash.filter(workPeriods, function(wp) {
      return wp.active;
    });
    $scope.allUsers = params.users;
    $scope.nowTime = TimeService.getNowInStoreTime();

    $scope.subtitle = $scope.dates[0].format('MMM D') + ' to ' + $scope.dates[6].format('MMM D');

    var weekRange = params.businessWeek;

    $scope.state = {
      collapse: {
        unavailability: true,
        timeOff: true,
        overtime: true,
        overlap: true,
        multiShift: true,
        overnightProximity: true,
        shiftGap: true,
        tooFewHours: true,
        tooFewHoursOnDay: true,
        noAvailability: true,
        tooManyHoursOnDay: true,
        overTargetHours: true
      },
      anyDaysInPast: $scope.nowTime.isAfter(weekRange.start)
    };

    $scope.close = function() {
      $uibModalInstance.close();
    };

    var weekProjections = lodash.filter(initialProjections, {type: 'weekly'});

    if (weekProjections.length > 0) {
      $scope.weekProjection = lodash.first(weekProjections);
    } else {
      $scope.weekProjection = {
        week_labor_percentage_goal: 0.0
      };
    }


    $scope.dailyProjections = lodash.map($scope.dates, function(dt, idx) {
      var temp;
      var dtFormatted = dt.format('YYYY-MM-DD');

      var projMatch = lodash.find(initialProjections, function(proj) {
        return proj.target_date === dtFormatted && proj.type === 'daily';
      });

      if (projMatch) {
        temp = projMatch;
      } else {
        temp = {
          cost: 0.0,
          gross_revenue: 0.0,
          labor_hours: 0.0
        };
      }

      return {
        date: dt,
        props: temp
      }
    });

    var wpIdsWithOverlap = []; //array of workPeriod IDS that have known overlap with another shift
    $scope.warnings = [];

    if ($scope.state.anyDaysInPast) {
      MWPCompositeAvailabilityService.getCompositeAvailability(moment(weekRange.start).subtract(1, 'days'), moment(weekRange.end))
        .then(function(compositeAvailabilityData) {
          console.log('compositeAvailabilityData: ', compositeAvailabilityData);
          if (compositeAvailabilityData) {
            $scope.compositeAvailability = compositeAvailabilityData;

            lodash.each($scope.allUsers, function(u, idx) {
              $scope.allUsers[idx].$mergeInAvailability($scope.compositeAvailability);
            });

            $scope.state.compositeAvailabilityLoaded = true;
          }
        }, function(response) {
          console.log('composite availablity data, else', response);
        });
    }

    $scope.userStatsByUserId = {};


    // Calculate all of the availability warning categories
    var calcAvailabilityWarnings = function(userId, workPeriods) {
      // if we are in the future, just use availability we already have
      // if in the past, then we need to pull the availability for the user
      var processAvailabilityForWorkPeriods = function(u, wps) {
        lodash.each(wps, function(wp) {
          var temp = lodash.map(lodash.filter(u.$overlapsWithAvailability(wp.range_twix).data, function(violation) {
            return violation.avail === 'false' && violation.approved;
          }), function(violation) {
            return {
              type: violation.type === 'single' ? 'timeOff' : 'unavailability',
              userId: u.id,
              data: {
                workPeriod: wp
              },
              departmentIds: [wp.position.department_id],
              value: violation
            };
          });
          $scope.warnings.push.apply($scope.warnings, temp);
        });
      };

      var calculateEmployeeHours = function(u, wps) {
        // count up all of the hours in the week
        var hrs = 0;
        if (wps.length > 0) {
          hrs = lodash.reduce(lodash.map(wps, function(wp) {
            return weekRange.intersection(wp.range_twix).length('minutes') / 60.0;
          }), function(sum, num) {
            return sum + num;
          });

          var overlapHours = 0,
            filteredWps = [],
            hoursSubtotal = 0,
            userDataByDay;
          userDataByDay = lodash.map($scope.dayTwixes, function(dtTwix) {
            hoursSubtotal = 0;
            filteredWps = lodash.filter(wps, function(wp) {
              overlapHours = wp.range_twix.overlaps(dtTwix) &&
              (Math.abs(wp.range_twix.intersection(dtTwix).length('minutes')) / 60.0);
              if (overlapHours > 0) {
                hoursSubtotal += overlapHours;
                return true;
              } else {
                return false;
              }
            });

            return {
              hours: hoursSubtotal,
              workPeriods: filteredWps
            };
          });

          lodash.each(userDataByDay, function(dayData, dayIdx) {
            if (dayData.hours <= 4) {
              $scope.warnings.push({
                type: 'tooFewHoursOnDay',
                userId: u.id,
                data: {
                  dayLaborHours: dayData.hours,
                  workPeriods: dayData.workPeriods,
                  twix: $scope.dayTwixes[dayIdx]
                },
                ranking: dayData.hours / 4.0,
                departmentIds: _(dayData.workPeriods).map(function(wp) {
                  if (wp.position.department) {
                    return wp.position.department.id;
                  } else {
                    return wp.position.department_id;
                  }
                }).unique().value(),
                value: dayData.hours
              });
            }

            if (dayData.hours >= 10) {
              $scope.warnings.push({
                type: 'tooManyHoursOnDay',
                userId: u.id,
                data: {
                  dayLaborHours: dayData.hours,
                  workPeriods: dayData.workPeriods,
                  twix: $scope.dayTwixes[dayIdx]
                },
                ranking: dayData.hours / 4.0,
                departmentIds: _(dayData.workPeriods).map(function(wp) {
                  if (wp.position.department) {
                    return wp.position.department.id;
                  } else {
                    return wp.position.department_id;
                  }
                }).unique().value(),
                value: dayData.hours
              });
            }

          });


        }

        var availabilitySets = lodash.filter([u.$effectiveAvailabilitySet(weekRange.start), u.$effectiveAvailabilitySet(weekRange.end)], function(val) {
          return !lodash.isUndefined(val);
        });
        var targetHours;
        if (availabilitySets.length > 0) {
          availabilitySets = lodash.uniqBy(availabilitySets, 'id');
          targetHours = lodash.map(availabilitySets, 'target_hours');
          var lowerTargetHours = _.min(targetHours);
          var availabilitySetIdx = lodash.findIndex(availabilitySets, lowerTargetHours);

          // if the hours this week are less than 3/4 of target hours
          if (lowerTargetHours * 0.75 > hrs && u.$curMemb().active > 0) {
            $scope.warnings.push({
              type: 'tooFewHours',
              userId: userId,
              data: {
                availabilitySets: availabilitySets,
                lowerTargetHours: lowerTargetHours,
                availabilitySetIndex: availabilitySetIdx,
                weekLaborHours: hrs,
                percentBelow: 100 - (hrs / lowerTargetHours * 100)
              },
              ranking: hrs / lowerTargetHours,
              departmentIds: _(u.users_positions).map(function(up) {
                if (up.position.department) {
                  return up.position.department.id;
                } else {
                  return up.position.department_id;
                }
              }).unique().value(),
              value: hrs
            });
          }

          if (hrs > lowerTargetHours && u.$curMemb().active > 0) {
            $scope.warnings.push({
              type: 'overTargetHours',
              userId: userId,
              data: {
                availabilitySets: availabilitySets,
                lowerTargetHours: lowerTargetHours,
                availabilitySetIndex: availabilitySetIdx,
                weekLaborHours: hrs,
                percentOver: ((hrs - lowerTargetHours) / lowerTargetHours * 100)
              },
              ranking: (hrs - lowerTargetHours) * -1,
              departmentIds: _(u.users_positions).map(function(up) {
                if (up.position.department) {
                  return up.position.department.id;
                } else {
                  return up.position.department_id;
                }
              }).unique().value(),
              value: hrs
            });
          }
        } else {
          var find = lodash.findIndex($scope.warnings, {type: 'noAvailability', userId: userId });

          if (find > -1) {
            $scope.warnings.splice(find, 1);
          }

          $scope.warnings.push({
            type: 'noAvailability',
            userId: userId,
            data: {
            },
            departmentIds: _(u.users_positions).map(function(up) {
              return up.position.department_id;
            }).unique().value(),
            value: null
          });
        }
      };

      // look if we have a matching user
      var u = lodash.find($scope.allUsers, {id: userId});

      if (u) {
        // we already have all of the availability we need for this user
        processAvailabilityForWorkPeriods(u, workPeriods);

        // also check out their availability -vs- target hours
        calculateEmployeeHours(u, workPeriods);

      } else {
        //console.info(userId, $scope.allUsers);
        // we don't have the availability we need for this user
        Users.getById(userId)
          .then(function(u) {

            u.$mergeInAvailability($scope.compositeAvailability);
            $scope.allUsers.push(u);

            processAvailabilityForWorkPeriods(u, workPeriods);
            calculateEmployeeHours(u, workPeriods);
            calcWarningsByType();
          }, function() {

          });
      }
    };

    var initUserStatData = function(u) {
      $scope.userStatsByUserId[u.id] = {
        laborHours: 0,
        targetHours: (function() {
          var activeSet = lodash.find(u.availability_sets, function(availSet) {
            return availSet.$isInEffect($scope.dates[0]) && availSet.$isApproved();
          });

          if (activeSet) {
            return activeSet.target_hours;
          } else {
            return null;
          }
        })(),
        workPeriods: [],
        prevWeekDayWorkPeriods: []
      };
    };

    lodash.each($scope.allUsers, function(u) {
      initUserStatData(u);
    });

    var fetchDataForUser = function(userId) {
      Users.getById(userId)
        .then(function(user) {
          $scope.allUsers.push(user);

          $scope.userStatsByUserId[user.id].target_hours = (function() {
            var activeSet = lodash.find(user.availability_sets, function(availSet) {
              return availSet.$isInEffect($scope.dates[0]) && availSet.$isApproved();
            });

            if (activeSet) {
              return activeSet.target_hours;
            } else {
              return null;
            }
          })();
        });
    };

    var userIdsWithWorkPeriods = [];
    var userIdsToFetchDataFor = [];

    lodash.each($scope.workPeriods, function(wp) {
      if (wp.$isAssigned() && wp.active) {
        userIdsWithWorkPeriods.push(wp.user.id);
        if (lodash.isUndefined($scope.userStatsByUserId[wp.user.id])) {
          //console.info('userId: ', wp.user.id, ' not in userStatsByUserId', $scope.userStatsByUserId[wp.user.id], lodash.find($scope.allUsers, {id: wp.user.id}));
          initUserStatData({id: wp.user.id, availability_sets: []});
          userIdsToFetchDataFor.push(wp.user.id);
        }


        if (weekRange.overlaps(wp.range_twix)) {
          $scope.userStatsByUserId[wp.user.id].laborHours += Math.abs(weekRange.intersection(wp.range_twix).length('minutes')) / 60.0;
          $scope.userStatsByUserId[wp.user.id].workPeriods.push(wp);
        } else if (!wp.start_time.isAfter(weekRange.end) && !wp.start_time.isSame(weekRange.end)) {
          $scope.userStatsByUserId[wp.user.id].prevWeekDayWorkPeriods.push(wp);
        }
      }
    });

    //console.log(userIdsWithWorkPeriods);


    lodash.each($scope.userStatsByUserId, function(userStats, userId) {
      // key is a string, convert back to integer
      userId = parseInt(userId);
      // put workPeriods in start order ASC
      userStats.workPeriods = _.sortBy(userStats.workPeriods, function(wp) {
        return wp.start_time.unix();
      });


      if (userStats.laborHours > $scope.org.organization_config.overtime_threshold_hours) {
        var temp = {
          type: 'overtime',
          userId: userId,
          ranking: userStats.laborHours - $scope.org.organization_config.overtime_threshold_hours,
          departmentIds: [],
          value: {
            diff: userStats.laborHours - $scope.org.organization_config.overtime_threshold_hours,
            totalHours: userStats.laborHours
          }
        };

        temp.departmentIds = _(userStats.workPeriods).map(function(wp) {
          return wp.position.department_id;
        }).unique().value();

        $scope.warnings.push(temp);
      }


      // keep record of the WP.id's that are overlapping so we don't double count with these nested loops
      // check if any workPeriods for this user overlap
      lodash.each(userStats.workPeriods, function(wp) {
        if (!_.include(wpIdsWithOverlap, wp.id)) {
          lodash.each(userStats.workPeriods, function(wp2) {
            // don't compare the same workPeriods
            if (wp.id !== wp2.id) {
              if (wp.range_twix.overlaps(wp2.range_twix)) {
                wpIdsWithOverlap.push(wp2.id);
                var inter = wp.range_twix.intersection(wp2.range_twix);
                $scope.warnings.push({
                  type: 'overlap',
                  userId: wp.user.id,
                  data: {
                    workPeriods: [wp, wp2],
                    intersection: inter
                  },
                  departmentIds: _.unique([wp.position.department_id, wp2.position.department_id]),
                  value: inter.length('minutes')
                });
              }
            }
          });
        }
      });

      // group the shifts by day of week for that user
      userStats.workPeriodsByDay = [[],[],[],[],[],[],[]];
      lodash.each(userStats.workPeriods, function(wp) {
        var dateIndex = lodash.findIndex($scope.dates, function(dt) {
          var twx = dt.twix(moment(dt).add(1, 'day').hour(0));
          return twx.contains(wp.start_time) || wp.start_time.isSame(dt);
        });

        if (dateIndex > -1) {
          userStats.workPeriodsByDay[dateIndex].push(wp);
        }
      });

      // let's look for double shifts and shifts w/o much time in between on two different days
      lodash.each(userStats.workPeriodsByDay, function(dayOfWorkPeriods, dayIdx) {
        if (dayOfWorkPeriods.length > 1 && _.all(dayOfWorkPeriods, function(wp, idx) {
            if (idx === 0) return true;

            return !wp.range_twix.overlaps(dayOfWorkPeriods[idx-1].range_twix);
          })) {
          $scope.warnings.push({
            type: 'multiShift',
            userId: userId,
            data: {
              workPeriods: dayOfWorkPeriods,
              numWorkPeriods: dayOfWorkPeriods.length
            },
            departmentIds: _(dayOfWorkPeriods).map(function(wp) {
              return wp.position.department_id;
            }).unique().value(),
            value: lodash.reduce(dayOfWorkPeriods, function(sum, wp) {
              return sum + (wp.range_twix.length('minutes') / 60.0);
            }, 0)
          });

          var inOrderWorkPeriods = _.sortBy(dayOfWorkPeriods, function(wp) {
            return wp.start_time.unix();
          });

          var workPeriodsWithGap = [];
          var workPeriodsWithGapTwix = [];

          lodash.each(inOrderWorkPeriods, function(wp, idz) {

            if (idz > 0) {
              var twx = inOrderWorkPeriods[idz-1].end_time.twix(inOrderWorkPeriods[idz].start_time);

              if (twx.length('minutes') > 0) {
                workPeriodsWithGap.push(inOrderWorkPeriods[idz-1]);
                workPeriodsWithGap.push(wp);
                workPeriodsWithGapTwix.push(twx);
              }
            }
          });

          workPeriodsWithGap = _.unique(workPeriodsWithGap, 'id');

          if (workPeriodsWithGap.length > 0) {
            $scope.warnings.push({
              type: 'shiftGap',
              userId: userId,
              data: {
                workPeriods: workPeriodsWithGap
              },
              departmentIds: _(workPeriodsWithGap).map(function(wp) {
                return wp.position.department_id;
              }).unique().value(),
              value: lodash.map(workPeriodsWithGapTwix, function(twx) {
                return twx;
              })
            });

          }
        }

        if (dayIdx > 0) {
          // see how long it was from the end of their last shift to their next shift (only on different days)
          if (userStats.workPeriodsByDay[dayIdx - 1].length > 0 && dayOfWorkPeriods.length > 0) {
            var timeBetweenShifts = moment(lodash.last(userStats.workPeriodsByDay[dayIdx - 1]).end_time).twix(moment(dayOfWorkPeriods[0].start_time));

            if (timeBetweenShifts.length('minutes') <= 480) {
              $scope.warnings.push({
                type: 'overnightProximity',
                userId: userId,
                data: {
                  workPeriods: [lodash.last(userStats.workPeriodsByDay[dayIdx - 1]), dayOfWorkPeriods[0]],
                  gapTwix: timeBetweenShifts
                },
                departmentIds: [lodash.last(userStats.workPeriodsByDay[dayIdx - 1]).position.department_id, dayOfWorkPeriods[0].position.department_id],
                value: timeBetweenShifts.length('minutes') / 60.0
              });
            }
          }
        } else {
          // look at last weeks workPeriods and see if there is overnight proximity across weeks
          if (userStats.prevWeekDayWorkPeriods.length > 0 && dayOfWorkPeriods.length > 0) {
            var timeBetweenShifts = moment(lodash.last(userStats.prevWeekDayWorkPeriods).end_time).twix(moment(dayOfWorkPeriods[0].start_time));

            if (timeBetweenShifts.length('minutes') <= 480) {
              $scope.warnings.push({
                type: 'overnightProximity',
                userId: userId,
                data: {
                  workPeriods: [lodash.last(userStats.prevWeekDayWorkPeriods), dayOfWorkPeriods[0]],
                  gapTwix: timeBetweenShifts
                },
                departmentIds: [lodash.last(userStats.prevWeekDayWorkPeriods).position.department_id, dayOfWorkPeriods[0].position.department_id],
                value: timeBetweenShifts.length('minutes') / 60.0
              });
            }
          }
        }
      });
    });

    var warningCalcTimeout = null;
    var warningTypes = ['unavailability', 'timeOff', 'overtime', 'overlap', 'multiShift',
      'overnightProximity', 'shiftGap', 'tooFewHours', 'tooFewHoursOnDay', 'noAvailability', 'tooManyHoursOnDay', 'overTargetHours'];
    var calcWarningsByType = function() {
      if (warningCalcTimeout) {
        $timeout.cancel(warningCalcTimeout);
      }

      $timeout(function() {
        $scope.warningsByType = {};
        $scope.warningsByTypeFiltered = {};
        var selectedDeptIds = lodash.map(lodash.filter($scope.allDepartments, {_selected: true}), 'id');
        lodash.each(warningTypes, function(prop) {
          $scope.warningsByType[prop] = lodash.filter($scope.warnings, {type: prop});
          $scope.warningsByTypeFiltered[prop] = lodash.filter($scope.warnings, function(warn) {
            return warn.type === prop && _.any(selectedDeptIds, function(deptId) {
                return lodash.includes(warn.departmentIds, deptId);
              });
          });
        });
      }, 100);
    };

    var calculateWeekStats = function() {
      $scope.workPeriodOverlapsByDay = lodash.map($scope.dates, function(dt) {
        var dtTwix = moment(dt).twix(moment(dt).add(1, 'days'));

        return lodash.filter(workPeriods, function(wp) {
          return wp.range_twix.overlaps(dtTwix) &&
            Math.abs(wp.range_twix.intersection(dtTwix).length('minutes')) > 0;

        });
      });

      $scope.dayAnalysisDataByDay = WeekCalculationService.calcWeekWorkPeriodStats($scope.dates,
        $scope.workPeriodOverlapsByDay,
        $scope.org.departments, $scope.org);

      $scope.allDepartments = lodash.map(lodash.cloneDeep($scope.org.departments), function(dept) {
        dept._selected = true;
        return dept;
      });
    };

    var calculateSummaryData = function() {
      var selectedDeptIds = lodash.map(lodash.filter($scope.allDepartments, {_selected: true}), 'id');
      $scope.state.numDepartmentsSelected = selectedDeptIds.length;

      // for each day aggregate the properties over selected departments
      $scope.statsDataByDay = lodash.map($scope.dayAnalysisDataByDay, function(day, idx) {
        var temp = {};
        temp.id = idx;
        temp.dateTwix = day.dateTwix;
        lodash.forEach(['numUnassignedUnpublishedWorkPeriodsStartingToday',
                   'numAssignedUnpublishedWorkPeriodsStartingToday',
                   'numAssignedPublishedWorkPeriodsStartingToday',
                   'numAssignedWorkPeriodsStartingToday',
                   'totalAssignedLaborHours'], function(prop) {
          temp[prop] = lodash.reduce(_.pick(day.departmentData, selectedDeptIds), function(accum, deptData) {
            return accum + deptData[prop];
          }, 0);
        });

        return temp;
      });

      calcWarningsByType();
    };

    calculateWeekStats();
    calculateSummaryData();

    calcWarningsByType();


    var doAvailabilityCalculations = function() {
      lodash.each($scope.allUsers, function(u) {
        //console.log(u.$curMemb().active);
        if (!lodash.includes(userIdsWithWorkPeriods, u.id) && u.$curMemb().active > 0) {
          //console.log('userId: ', u.id, 'does not have workPeriods');
          calcAvailabilityWarnings(u.id, []);
        }
      });

      lodash.each($scope.userStatsByUserId, function(userStats, userId) {
        calcAvailabilityWarnings(parseInt(userId), userStats.workPeriods);
      });

      calcWarningsByType();
    };

    var intervalAvailabilityDereg = $interval(function() {
      console.info('interval exec');
      if (!$scope.state.anyDaysInPast || ($scope.state.anyDaysInPast && $scope.state.compositeAvailabilityLoaded)) {
        doAvailabilityCalculations();
        $interval.cancel(intervalAvailabilityDereg);
      }
    }, 100);


    $scope.getUser = function(userId) {
      return lodash.find($scope.allUsers, {id: userId});
    };

    var getDayFromWp = function(wp) {
      return lodash.find($scope.dates, function(dt) {
        var twx = dt.twix(moment(dt).add(1, 'day').hour(0));
        return twx.contains(wp.start_time) || wp.start_time.isSame(dt);
      });
    };

    $scope.goToWorkPeriodsOnMWP = function(warning) {
      var workPeriodIds = [];
      var dt;
      if (warning.type === 'unavailability') {
        workPeriodIds.push(warning.data.workPeriod.id);
        dt = getDayFromWp(warning.data.workPeriod);
      } else if (warning.type === 'timeOff') {
        workPeriodIds.push(warning.data.workPeriod.id);
        dt = getDayFromWp(warning.data.workPeriod);
      } else if (warning.type === 'overtime') {

      } else if (warning.type === 'overlap') {
        workPeriodIds.push.apply(workPeriodIds, lodash.map(warning.data.workPeriods, 'id'));
        dt = getDayFromWp(lodash.last(warning.data.workPeriods));
      } else if (warning.type === 'multiShift') {
        workPeriodIds.push.apply(workPeriodIds, lodash.map(warning.data.workPeriods, 'id'));
        dt = getDayFromWp(lodash.last(warning.data.workPeriods));
      } else if (warning.type === 'overnightProximity') {
        workPeriodIds.push.apply(workPeriodIds, lodash.map(warning.data.workPeriods, 'id'));
        dt = getDayFromWp(lodash.last(warning.data.workPeriods));
      } else if (warning.type === 'shiftGap') {
        workPeriodIds.push.apply(workPeriodIds, lodash.map(warning.data.workPeriods, 'id'));
        dt = getDayFromWp(lodash.last(warning.data.workPeriods));
      } else if (warning.type === 'tooFewHours') {

      } else if (warning.type === 'tooFewHoursOnDay') {
        workPeriodIds.push.apply(workPeriodIds, lodash.map(warning.data.workPeriods, 'id'));
        dt = getDayFromWp(lodash.last(warning.data.workPeriods));
      } else if (warning.type === 'tooManyHoursOnDay') {
        workPeriodIds.push.apply(workPeriodIds, lodash.map(warning.data.workPeriods, 'id'));
        dt = getDayFromWp(lodash.last(warning.data.workPeriods));
      } else if (warning.type === 'overTargetHours') {

      }

      if (dt) {
        MWPHighlightService.highlightWorkPeriods(workPeriodIds, dt, 5000, warning);
        $uibModalInstance.close();
      }
    };

    $scope.toggleCollapse = function(collapseName) {
      if ($scope.warningsByType[collapseName].length > 0) {
        $scope.state.collapse[collapseName] = !$scope.state.collapse[collapseName];
      }
    };

    $scope.toggleDepartmentSelection = function(dept) {
      dept._selected = !dept._selected;
      calculateSummaryData();
    };

    // console.info('userIdsToFetchDataFor', lodash.uniq(userIdsToFetchDataFor));
    lodash.each(lodash.uniq(userIdsToFetchDataFor), function(userId) {
      fetchDataForUser(userId);
    });

  });
